import React, { Fragment } from "react";

import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";

import { Container, ContainerGeral } from "./styles";

interface LoadingComponentProps {
  label?: string;
  id?: string;
  loading: boolean;
}

export const LoadingComponent: React.FC<LoadingComponentProps> = ({
  loading,
  id,
  label,
}) => {
  const { t } = useTranslation();
  return loading ? (
    <Fragment>
      <ContainerGeral />
      <Container id={id} data-testid={id}>
        <span>{label || t("common.loading")}</span>
        <ReactLoading type="spin" color="#F2A60D" width={24} height={24} />
      </Container>
    </Fragment>
  ) : (
    <div hidden />
  );
};

export default LoadingComponent;
